<div class="marriottWelcomeBanner" *ngIf="showBanner">
  <img loading="lazy" [src]="imageName | baseImage : imageBasePath" alt="Marriott Bonvoy Logo">
</div>